import {
  GET_EMPLOYEE_ENTRIES_REQUEST,
  GET_EMPLOYEE_ENTRIES_ERROR,
  GET_EMPLOYEE_ENTRIES_SUCCESS,
  CREATE_EMPLOYEE_ENTRIES_REQUEST,
  CREATE_EMPLOYEE_ENTRIES_ERROR,
  CREATE_EMPLOYEE_ENTRIES_SUCCESS,
  UPDATE_EMPLOYEE_ENTRIES_REQUEST,
  UPDATE_EMPLOYEE_ENTRIES_ERROR,
  UPDATE_EMPLOYEE_ENTRIES_SUCCESS,
  DELETE_EMPLOYEE_ENTRIES_REQUEST,
  DELETE_EMPLOYEE_ENTRIES_ERROR,
  DELETE_EMPLOYEE_ENTRIES_SUCCESS,
  CREATE_ENTRY_REQUEST,
  CREATE_ENTRY_ERROR,
  CREATE_ENTRY_SUCCESS,
  UPDATE_ENTRY_OBJ,
  EDIT_ENTRY_SUCCESS
} from "../../actions/types";
import reducers from "../common"

const initialState = {};
export default (state = initialState, action) => {

  reducers.init(reducers);

  reducers.GET_ENTITY_REQUEST = GET_EMPLOYEE_ENTRIES_REQUEST;
  reducers.GET_ENTITY_ERROR = GET_EMPLOYEE_ENTRIES_ERROR;
  reducers.GET_ENTITY_SUCCESS = GET_EMPLOYEE_ENTRIES_SUCCESS;
  reducers.CREATE_ENTITIES_REQUEST = CREATE_EMPLOYEE_ENTRIES_REQUEST;
  reducers.CREATE_ENTITIES_ERROR = CREATE_EMPLOYEE_ENTRIES_ERROR;
  reducers.CREATE_ENTITIES_SUCCESS = CREATE_EMPLOYEE_ENTRIES_SUCCESS;
  reducers.UPDATE_ENTITY_REQUEST = UPDATE_EMPLOYEE_ENTRIES_REQUEST;
  reducers.UPDATE_ENTITY_ERROR = UPDATE_EMPLOYEE_ENTRIES_ERROR;
  reducers.UPDATE_ENTITY_SUCCESS = UPDATE_EMPLOYEE_ENTRIES_SUCCESS;
  reducers.DELETE_ENTITY_REQUEST = DELETE_EMPLOYEE_ENTRIES_REQUEST;
  reducers.DELETE_ENTITY_ERROR = DELETE_EMPLOYEE_ENTRIES_ERROR;
  reducers.DELETE_ENTITY_SUCCESS = DELETE_EMPLOYEE_ENTRIES_SUCCESS;
  reducers.entityName = "employeeEntries";

  if (action.type === UPDATE_ENTRY_OBJ && action.payload.entryType === reducers.entityName) {
    const employeeInState = action.payload.fullState.employee.employee
    const newEmployee = employeeInState ? employeeInState[action.payload.entry.Employee.ID] : null
    delete action.payload.entry.Pensum
    return {
      ...state,
      [action.payload.entryType]: {
        ...state[action.payload.entryType],
        [action.payload.entry.ID]: {
          ...state[action.payload.entryType][action.payload.entry.ID],
          ...action.payload.entry,
          Employee: newEmployee ? newEmployee : state[action.payload.entryType][action.payload.entry.ID].Employee
        }
      }
    }
  }
  if (action.type === EDIT_ENTRY_SUCCESS && action.entryType === "EmployeeEntries") {
    const entryName = action.entryType.charAt(0).toLowerCase() + action.entryType.slice(1)
    return {
        ...state,
        [entryName]: {
          ...state[entryName],
          [action.payload.ID]: {
            ...state[entryName][action.payload.ID],
            ...action.payload
          }
        },
        isFetching: false,
        error: undefined
    }
  }
  if (action.type === CREATE_ENTRY_REQUEST && action.entryType === "EmployeeEntries") {
    return {
      ...state,
      isFetching: true,
      error: undefined
    }
  }
  if (action.type === CREATE_ENTRY_SUCCESS && action.entryType === "EmployeeEntries") {
    return {
      ...state,
      employeeEntries: {
        ...state.employeeEntries,
        [action.payload.ID]: {
          ...action.payload
        }
      },
      isFetching: false,
      error: undefined
    }
  }
  if (action.type === CREATE_ENTRY_ERROR && action.entryType === "EmployeeEntries") {
    return {
      ...state,
      isFetching: false,
      error: `${action.error}`
    }
  }

  return reducers.entity(reducers)(state, action);
};
